export const handleKeyDown = (e: any) => {
  if (!(e.key === "Tab" || e.key === "Shift")) {
    e.preventDefault();
  }
};
